<template>
    <div class="taurus-form-control taurus-form-telphone-input" :class="wrapperClass">
      <label :for="id">{{label}}</label>
      <input type="telephone" 
            :id="id" 
            :ref="id"
            :fieldlabel="validationFieldLabel"
            v-model="inputValue"
            :v-taurus-validator="validationRules ? validationRules : false"
            :class="inputClass"
            :placeholder="placeholder"
            @input="onInput">
      <div class="taurus-form-control-validation" :name="id" :invalidfeedback="validationInvalidFeedback"></div>
    </div>
</template>
<script>
import { parsePhoneNumber } from 'libphonenumber-js';
export default {
        props: {
            value: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: () => { return this.id }
            },
            placeholder: {
                type: String,
                required: false
            },
            returnFormatE164: {
                type: Boolean,
                required: false,
                default: () => { return false }
            },
            validationRules: {
                type: String,
                required:false
            },
            validationFieldLabel: {
                type: String,
                required:true
            },
            validationInvalidFeedback: {
                type: String,
                required:true
            },
            wrapperClass: {
                type: String,
                required: false,
                default: 'form-group'
            },
            inputClass: {
                type: String,
                required: false,
                default: 'form-control form-control-lg'
            }
        },
        data: () => {
            return {
                inputValue: null,
            }
        },
        mounted() {
            this.inputValue = this.value            
        },
        watch: {
            value(newVal,oldVal) {
                if (newVal != oldVal) {
                    this.inputValue = this.value
                }
            },
            inputValue(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.$emit('input', this.returnFormatE164 ? this.formatValue : this.inputValue)
                }
            }
        },
        computed: {
            formatValue() {
                if (this.inputValue) {
                    if (this.inputValue.length > 2) {
                        if (this.inputValue[0] === '+') {
                            let result = parsePhoneNumber(this.inputValue) || {};
                            return result.format('E.164')
                        } else {
                            let result = parsePhoneNumber(this.inputValue, 'GB') || {};
                            return result.format('E.164')
                        }
                    }
                }
                return null
            }
        },
        methods: {
            onInput(e) {
                //FormBus.$emit('FormTextInput-onInput', { controlId: this.id, value: this.inputValue, event: e })
            }
        }
    }
</script>